import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { DateTime } from 'luxon'

import { useFulfillment } from '../FulfillmentProvider/FulfillmentProvider'
import { toRelativeDateString } from '../../utils/time-utils'

import './FutureEstimate.css'

export const FutureEstimate = ({ editable }) => {
  const { fulfillmentTime } = useFulfillment()

  let fulTime = fulfillmentTime || new Date().toISOString()

  const dt = DateTime.fromISO(fulTime)
  const date = toRelativeDateString(fulTime)
  const time = dt.toLocaleString(DateTime.TIME_SIMPLE)

  return (
    <React.Fragment>
      <span data-testid='fulfillment-scheduled-ready-date' styleName={cx('emphasis', { editable })}>{date}&nbsp;</span>at
      <span data-testid='fulfillment-scheduled-ready-time' styleName={cx('emphasis', { editable })}>&nbsp;{time}&nbsp;</span>
    </React.Fragment>
  )
}

FutureEstimate.propTypes = {
  editable: PropTypes.bool
}
